import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {useDispatch, useSelector } from "react-redux";
import { Radio } from "@rmwc/radio";
import AddEditBillingInfo from "./common/AddEditBillingInfo.js";
import { const_var } from "../../../redux/reducers/reducer.js";
import { commonsActionforLeadCustomer } from "../../../action/quote_order/leadcustomer.action.js";

const AddLeadCustomer = () => {
	const dispatch = useDispatch();
	const { showCustomerLeadRecord, is_module_name, searchType } = useSelector((state) => state.leadcustomerReducer);
	let showLeadCustomerRadio =
		(const_var.crmSetting.is_module_name == "quote" && const_var.crmSetting.is_Edit == false) ||
		(const_var.prevModuleType == "inventory" && const_var.crmSetting.is_Edit == true && const_var.crmSetting.is_module_name == "quote") ||
		(const_var.crmSetting.is_module_name == "quote" && const_var.isFromCompare == true);

	return (
		<>
			<div className="form-wrapper form-wrapper-2">
				<div className="d-flex text-left">
					<h5 className="modal-title">{showCustomerLeadRecord ? "Billing Address" : is_module_name == "order" ? "Add New Customer" : showLeadCustomerRadio == true ? "Add New" : "Add New Lead"}</h5>

					{showLeadCustomerRadio == true ? (
						<div className="radio-group ml-2">
							<Radio
								label="Leads"
								value={searchType}
								name="myRadioGroup"
								checked={searchType == "Leads" ? true : false}
								onChange={(e) => dispatch(commonsActionforLeadCustomer("Leads", "Search"))}
								className={is_module_name == "order" ? "d-none" : ""}
							/>
							<Radio
								label="Customers"
								value={searchType}
								name="myRadioGroup"
								className="ml-2"
								checked={searchType == "Customers" ? true : false}
								onChange={(e) => dispatch(commonsActionforLeadCustomer("Customers", "Search"))}
							/>
						</div>
					) : null}
				</div>
				<AddEditBillingInfo />
			</div>
		</>
	);
};

export default AddLeadCustomer;
